/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable dot-notation */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, ChangeEvent } from 'react';
import { Grid } from '@mui/material';
import { FormikHelpers, FormikProvider, useFormik } from 'formik';
import Divider from '@mui/material/Divider';
import _ from 'lodash';
import Swal from 'sweetalert2';

import { ReactComponent as Save } from 'design_system/src/static/icons/save.svg';
import { ReactComponent as Image } from 'design_system/src/static/icons/image.svg';
import { ReactComponent as Close } from 'design_system/src/static/icons/close-sm.svg';

import { Button, Input, Typography, SideModal } from 'design_system/src';

// css
import { toasterOptions } from 'models/shared/enums/toaster.enum';
import {
	AddVehicleFileDto,
	VehiclePopulated,
} from 'models/inventory/interfaces/vehicle.interface';
import { VehicleEvidenceDocumentType } from 'models/inventory/enums/vehicle.enum';
import { addVehicleFile } from 'models/inventory/controllers/vehicle.controller';
import { toasterNotification } from 'models/shared/helpers/toasterNotification';
import { toast } from 'react-toastify';
import {
	addVehicleFileValidationSchema,
	typeOfDocumentOptions,
} from './constants';

interface AddVehicleFileProps {
	open: boolean;
	setOpen: Function;
	vehicle: VehiclePopulated;
	setResult: Function;
}

function AddVehicleFile({
	open,
	setOpen,
	vehicle,
	setResult,
}: AddVehicleFileProps) {
	const { internalId, invoiceId } = vehicle;
	const [loading, setLoading] = useState<boolean>(false);
	const [fileName, setFileName] = useState<string>('');

	const onSubmit = (
		vals: AddVehicleFileDto,
		form: FormikHelpers<AddVehicleFileDto>,
	) => {
		setLoading(true);
		const toastId = toasterNotification({
			toasterType: toasterOptions.warning,
			msg: 'Subiendo el documento',
			style: 'light',
		});
		addVehicleFile(
			internalId,
			vals.typeOfDocument,
			vals.file,
			vals.typeOfDocument === VehicleEvidenceDocumentType.invoice
				? vals.invoiceId
				: undefined,
		)
			.then((_value) => {
				toast.dismiss(toastId);
				toasterNotification({
					msg: 'Documento añadido',
					style: 'light',
					toasterType: toasterOptions.success,
				});
				setResult(_value);
				setOpen(false);
			})
			.catch((e) => {
				toast.dismiss(toastId);
				toasterNotification({
					msg: e.message,
					style: 'light',
					toasterType: toasterOptions.error,
				});
			});
	};

	const initialValues: AddVehicleFileDto = {
		file: undefined as any,
		typeOfDocument: undefined as unknown as VehicleEvidenceDocumentType,
		invoiceId,
	};

	const form = useFormik<AddVehicleFileDto>({
		initialValues,
		validationSchema: addVehicleFileValidationSchema,
		onSubmit,
		enableReinitialize: true,
		validateOnMount: true,
	});

	const handleFile = (e: ChangeEvent<HTMLInputElement>) => {
		const file = e.target.files?.[0];
		if (file) {
			if (file.size > 10000000) {
				Swal.fire({
					text: 'La imagen no debe ser superior a 10mb',
					icon: 'warning',
					confirmButtonText: 'Aceptar',
				});
				return;
			}

			form.setFieldValue('file', file);
			setFileName(file.name);
		} else {
			form.setFieldValue('file', undefined);
			setFileName('');
		}
	};

	const handleClear = () => {
		form.setFieldValue('file', undefined);
	};

	return (
		<SideModal open={open} setOpen={setOpen} size="small">
			<FormikProvider value={form}>
				<div className="flex_header">
					<Typography
						scale="heading4"
						weight="600"
						textColor="neutral_900"
						className="m_b_lg m_t_md"
					>
						Subir documento
					</Typography>
					<Divider />
				</div>
				<div className="flex_body p_y_lg p_x_sm overflow_x_hidden">
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<Input
								onChange={form.handleChange}
								onBlur={form.handleBlur}
								error={
									!!form.errors.typeOfDocument &&
									form.getFieldMeta('typeOfDocument').touched
								}
								subtitle={
									form.getFieldMeta('typeOfDocument').touched
										? form.errors.typeOfDocument
										: undefined
								}
								title="Tipo de documento"
								placeholder="Selecciona una opción"
								name="typeOfDocument"
								type="select"
								options={typeOfDocumentOptions}
								className="m_b_xs w_100_per"
								value={form.values.typeOfDocument}
							/>
						</Grid>
						<Grid item xs={12}>
							<div
								className={`dso_input_cont ${
									form.touched.file && Boolean(form.errors.file)
										? 'dso_input_error'
										: ''
								}`}
							>
								<div className="dso_input_title">
									<div className="dso_input_text">Seleccionar archivo</div>
								</div>
								<input
									type="file"
									accept=".pdf"
									onChange={handleFile}
									className={`dso_input${fileName !== '' ? ' input-file' : ''}`}
								/>
								{fileName !== '' && (
									<div className="display_flex flex_align_center flex_justify_between br_xxs border_1 border_solid border_primary_300">
										<Image className="dim_lg m_xs text_primary_300 border_transparent" />
										<Typography
											scale="medium"
											weight="400"
											textColor="primary_300"
											className=""
										>
											{fileName}
										</Typography>
										<Close
											className="dim_xl m_xs text_primary_300 border_transparent"
											onClick={handleClear}
										/>
									</div>
								)}
								<div className="dso_input_subtitle">
									{form.getFieldMeta('file').touched ? form.errors.file : ''}
								</div>
							</div>
						</Grid>
						{form.values.typeOfDocument ===
							VehicleEvidenceDocumentType.invoice && (
							<Grid item xs={12}>
								<Input
									onChange={form.handleChange}
									onBlur={form.handleBlur}
									error={
										!!form.errors.invoiceId &&
										form.getFieldMeta('invoiceId').touched
									}
									subtitle={
										form.getFieldMeta('invoiceId').touched
											? form.errors.invoiceId
											: undefined
									}
									title="Folio id"
									placeholder="Ingresa el folio id de la refactura"
									name="invoiceId"
									type="text"
									className="m_b_xs w_100_per"
									value={form.values.invoiceId}
								/>
							</Grid>
						)}
					</Grid>
				</div>
				<div className="flex_footer">
					<Button
						scale="small"
						orientation="right"
						icon={<Save />}
						className="m_b_xs w_100_per"
						type="submit"
						onClick={() => {
							form.handleSubmit();
						}}
						disabled={loading || !form.dirty || !form.isValid}
					>
						Guardar
					</Button>
				</div>
			</FormikProvider>
		</SideModal>
	);
}

export default AddVehicleFile;
